import { render, staticRenderFns } from "./InputTextDeData.vue?vue&type=template&id=53018290&scoped=true"
import script from "./InputTextDeData.vue?vue&type=script&lang=js"
export * from "./InputTextDeData.vue?vue&type=script&lang=js"
import style0 from "./InputTextDeData.vue?vue&type=style&index=0&id=53018290&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53018290",
  null
  
)

export default component.exports